export const SMALL = 'small';
export const VERY_SMALL = 'very-small';
